/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    brand?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrderItem
     */
    metadata?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    quantity?: number;
}

/**
 * Check if a given object implements the OrderItem interface.
 */
export function instanceOfOrderItem(value: object): boolean {
    return true;
}

export function OrderItemFromJSON(json: any): OrderItem {
    return OrderItemFromJSONTyped(json, false);
}

export function OrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'sku': json['sku'] == null ? undefined : json['sku'],
        'name': json['name'] == null ? undefined : json['name'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function OrderItemToJSON(value?: OrderItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sku': value['sku'],
        'name': value['name'],
        'brand': value['brand'],
        'metadata': value['metadata'],
        'quantity': value['quantity'],
    };
}

